module.exports = __webpack_public_path__ + "static/media/1-2_Art_Card_Two_Page_02.430fd862.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/1-2_Art_Card_Two_Page_02.jpg
// module id = 1701
// module chunks = 0